import { Fragment, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Layout, Tabs } from 'antd';
import { getLiveOneByIdApi } from '@services/Conference';
import './index.less';
import Appointment from './components/Appointment';
import Signup from './components/SignUp';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
export default function LiveComments() {
    const params = useParams();
    const conferenceId = parseInt(params?.id) || 0; // 会议项目 ID
    const liveId = parseInt(params?.liveId) || 0; // 直播 ID

    const [liveOneData, setLiveOneData] = useState({});
    const [tableComponents, setTableComponents] = useState(<Appointment />);

    // tab切换
    const onTabChange = key => {
        if (key === '1') {
            setTableComponents(<Appointment />);
        }
        if (key === '2') {
            setTableComponents(<Signup />);
        }
    };

    // 获取直播信息
    useEffect(() => {
        getLiveOneByIdApi({ id: liveId }).then(res => {
            if (res.status_code === 200) {
                setLiveOneData(res.data);
            }
        });
    }, []);

    useEffect(() => {
        document.title = '预约报名数据-医会议';
    }, []);

    return (
        <Fragment>
            <PageHeader
                title={`预约报名数据${liveOneData?.name ? ` · ${liveOneData.name}` : ''}`}
                breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, { label: '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}` }, { label: '直播管理', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}/lives` }, '预约报名数据']}
            />

            <div className="page-route-body live-signup-page">
                <Tabs
                    defaultActiveKey="1"
                    onChange={onTabChange}
                    items={[
                        {
                            label: '预约数据',
                            key: '1',
                        },
                        {
                            label: '报名数据',
                            key: '2',
                        },
                    ]}
                />

                <div className="table-components">{tableComponents}</div>
            </div>
        </Fragment>
    );
}
